import React from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, } from "@material-ui/core";

const SecondaryThrustModal = ({ enableSecondaryThrust, enableThrust, isLoading, toggleModal }) => {
    return (
        <Dialog
            open={true}
            className='console-management-modal'
        >
            <DialogTitle id="scroll-dialog-title">
                {enableThrust ? "This will enable the thrust categories for Secondary LLP and will follow the same thrust categories as the Primary LLP." : "This will disable the Thrust Categories for Secondary LLP and will merge all thrust-level values into a consolidated total."}
            </DialogTitle>
            <DialogContent dividers>
                <div style={{display:"flex",justifyContent:"center"}}>
                Are you sure you want {enableThrust ? "enable" : "disable"}?
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={toggleModal} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button onClick={() => enableSecondaryThrust(enableThrust)} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SecondaryThrustModal